<app-navbar></app-navbar>
<div>
    <div class="card">
      <video class="responsive-video img-fluid" autoplay [muted]="'muted'" loop>
        <source src="../../../assets/images/video/SFEA_Intro_fin.mp4" type="video/mp4">
      Your browser does not support the video tag.
      </video>
  </div>

    <!-- Course card -->
    <hr>
    <div class="container-responsive">
      <h2 style="text-align: center;color: #000000;">INTRODUCTION TO ELECTRIC VEHICLE</h2>
      
      <div id="divcard">
        <div class="row">
            <div class="col-12 col-sm-6">
                <p>Enrollments</p>
                <h3>{{ values-4 }}</h3>
            </div>
            <div class="col-12 col-sm-6">
                <p>Skill Level</p>
                <h3>{{ course.skilllevel }}</h3>
            </div>
        </div>
    </div>
       <div class="row">
        <ng-container *ngFor='let c of filteredModules; let i=index'>
          <div class="col-12 col-sm-6 mb-4">
            <div class="card img-fluid stagecard" style="width: 100%;">
              <img class="card-img-top img-fluid" [src]="c.imageUrl" alt="c.module" style="width:100%">
              <div class="card-img-overlay overlaycolor">
                <h4 class="card-title overlaytext">{{ c.module }}</h4>
                <p class="card-text overlaytext">{{ c.description }}</p>
                
                <a [routerLink]="['/courses/:id/course/',c.id]" class="btn solarwhite modulebutton btn-block-sm" style="color: #000000;">VIEW MORE</a>
              </div>
            </div>
          </div>
          <div *ngIf="(i+1) % 2 === 0"></div>    
        </ng-container>
       </div>        
    </div>
</div>